import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'AppUninstallNotAllowedModal',
  props: {
  message: {
    type: String,
    required: true,
  },
},
  emits: ["cancel"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    onCancel: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
  }, {
    title: _withCtx(() => [...(_cache[2] || (_cache[2] = [
      _createElementVNode("p", { class: "modal-card-title" }, "Unable to uninstall app", -1)
    ]))]),
    body: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(__props.message), 1),
      _cache[3] || (_cache[3] = _createElementVNode("p", null, [
        _createElementVNode("br"),
        _createTextVNode("Please contact support for assistance.")
      ], -1))
    ]),
    buttons: _withCtx(() => [
      _createVNode(_component_n_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel'))),
        variant: "primary"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
          _createTextVNode(" Cancel ", -1)
        ]))]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})